import { Value } from 'baseui/select'
import { SetDeviceForceUpdateMutation, SetDeviceForceUpdateMutationVariables } from '../../DeviceConfig/device_schemas'
import { generateContext } from '../../../utils'
import { TrajectoryViewState } from './trajectory_configuration_types'

export interface TrajectoryConfigurationContextInterface {
    loadingFetchSystemImage: any
    dataDB: any
    data: any
    setData: (key: string, newData: any) => void
    filterData: any
    setFilterData: (key: string, newData: any, index: number) => void
    filterDataDB: any
    addNewFilter: () => void
    deleteFilter: (index: number) => void
    currentFilter: number | null | undefined
    setCurrentFilter: (index: number | undefined) => void
    image: any
    imageSize: any
    latestImage: any
    setLatestImage: (latestImage: any | null | undefined) => void
    validationModalStatePolygon: any
    setValidationModalStatePolygon: (show: any | null | undefined, description: any | null | undefined) => void
    viewMode: Value
    setViewMode: React.Dispatch<React.SetStateAction<Value>>
    trajectoryViewCoordinates: any
    setTrajectoryViewDirection: (direction: string) => void
    setCoordinasetTrajectoryViewMissingLP: (direction: boolean) => void
    setEnableTrajectoryView: (value: boolean) => void
    trajectoryViewDirection: string
    trajectoryViewMissingLP: boolean
    enableTrajectoryView: boolean
    vehicleDetectionsTrajectoryView: TrajectoryViewState
    setVehicleDetectionsTrajectoryView: (key: keyof TrajectoryViewState, value: any) => void
    lpDetectionsTrajectoryView: TrajectoryViewState
    setLpDetectionsTrajectoryView: (key: keyof TrajectoryViewState, value: any) => void
    bestDetection: number
    setBestDetection: (value: number) => void
    setDeviceForceUpdate: (
        input: SetDeviceForceUpdateMutationVariables
    ) => Promise<SetDeviceForceUpdateMutation | undefined>
    loadingForceUpdate: boolean
    loadLiveViewScreenshotHandler: () => Promise<void>
    removeLiveViewUrl: () => void
    loading: boolean
    selectedImageSource: number
    setSelectedImageSource: React.Dispatch<React.SetStateAction<number>>
}
const [TrajectoryConfigurationContext, TrajectoryConfigurationProvider] =
    generateContext<TrajectoryConfigurationContextInterface>()
export { TrajectoryConfigurationContext, TrajectoryConfigurationProvider }
